import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NeoVerticalNavModule } from '@neogov/pattern-library/neo-vertical-nav';
import { ISidebarNavItem } from './interfaces';
import { ChipComponent } from '../chip';
import { IconComponent } from '../icon';
import { TooltipDirective } from '@presentation/directives';
import { PlatformProvider } from 'src/app/core/providers';

@Component({
  selector: 'cm-sidebar-menu',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive, NeoVerticalNavModule, IconComponent, ChipComponent, TooltipDirective],
  templateUrl: './sidebar-menu.component.html',
  styleUrl: './sidebar-menu.component.less',
})
export class SidebarMenuComponent {
  private readonly _platform = inject(PlatformProvider);

  public readonly items = input.required<ISidebarNavItem[]>();
  public readonly headerIcon = input<string>('');
  public readonly headerTitle = input<string>('');
  public readonly ariaLabel = input<string>('Navigation');

  public readonly headingId = `cm-sidebar-heading-${Date.now()}`;
  public readonly collapsed = signal<boolean>(this._platform.isScreenSMX());
  
  private readonly _isSmallScreenPrev = signal(this._platform.isScreenSMX());
  private readonly _isSmallScreenCurrent = computed(() => this._platform.isScreenSMX());

  constructor() {
    effect(() => {
      if (this._isSmallScreenPrev() === this._isSmallScreenCurrent()) {
        return;
      }

      if (!this._isSmallScreenPrev() && this._isSmallScreenCurrent()) {
        this.collapsed.update(() => true);
      } else if (this._isSmallScreenPrev() && !this._isSmallScreenCurrent()) {
        this.collapsed.update(() => false);
      }

      this._isSmallScreenPrev.update(() => this._isSmallScreenCurrent());
    });
  }

  public toggleCollapsed(): void {
    this.collapsed.set(!this.collapsed());
  }

  public onNavigated(): void {
    if (this._isSmallScreenCurrent()) {
      this.collapsed.update(() => true);
    }
  }
}
